module.exports = __webpack_public_path__ + "static/img/logo.c38cb0df.png";